/**
 * クロス設定登録画面 クロス商品情報一覧取得(リクエストパラメータ)用クラス
 *
 * @export CrossGoodsInfoList
 * @class CrossGoodsInfoList
 */
export class CrossGoodsInfoList {
  /** 受注コード */
  public orderCode = String('');
  /** クロスコード */
  public crossCode = String('');
  /** 媒体区分 */
  public mediumType = String('');
}
